import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import sw from "./locales/sw.json";
import fr from "./locales/fr.json";

export const languages = [
  { code: "en", label: "English", dir: "ltr" as const, flag: "🇬🇧" },
  { code: "ar", label: "العربية", dir: "rtl" as const, flag: "🇸🇦" },
  { code: "sw", label: "Kiswahili", dir: "ltr" as const, flag: "🇰🇪" },
  { code: "fr", label: "Français", dir: "ltr" as const, flag: "🇫🇷" },
];

const savedLang = typeof window !== "undefined" ? localStorage.getItem("language") || "en" : "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
    sw: { translation: sw },
    fr: { translation: fr },
  },
  lng: savedLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

// Set initial direction
const initialLang = languages.find((l) => l.code === savedLang);
if (initialLang && typeof document !== "undefined") {
  document.documentElement.dir = initialLang.dir;
  document.documentElement.lang = initialLang.code;
}

// Update direction on language change
i18n.on("languageChanged", (lng) => {
  const lang = languages.find((l) => l.code === lng);
  if (lang && typeof document !== "undefined") {
    document.documentElement.dir = lang.dir;
    document.documentElement.lang = lang.code;
    localStorage.setItem("language", lng);
  }
});

export default i18n;
